import { useState, useEffect } from 'react';
import {
  getFilterSaveList,
  updateFilterSaveList,
  delFilterSaveList,
} from '@/pages/intelligence/services/common';
import { useIntl, useDispatch, useSelector } from 'umi';
import {
  FILTER_NAMESPACE,
  DEFAULT_FILTER_SAVE_LIST_BY_TYPE_ITEM,
} from '@/pages/intelligence/models/filter';
import { notification } from 'tea-component';

interface IFilterSaveStateItem {
  loading: boolean;
  data: any;
}

interface FilterSavePropsType {
  // updataFilterParams: any;
  // execute?: boolean;
  filterSaveType?: string;
  useFilterSaveListByType?: boolean;
}
function useFilterSaveHook(props: FilterSavePropsType = {}) {
  // const { execute = false } = props;
  // console.log('useFilterSaveHook', props);
  const { filterSaveType = '', useFilterSaveListByType = false } = props;
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [filterData, setFilterData] = useState<any>([]);

  const { filterSaveList, filterSaveListKpiTrends, filterSaveListByType } = useSelector((state) => {
    // @ts-ignore
    const { filterSaveList, filterSaveListKpiTrends, filterSaveListByType } = state[FILTER_NAMESPACE];
    return {
      filterSaveList,
      filterSaveListKpiTrends,
      filterSaveListByType,
    };
  });

  useEffect(() => {
    if (filterSaveType !== '') {
      if (useFilterSaveListByType) {
        const filterSaveListCurrent: IFilterSaveStateItem =
          filterSaveListByType?.[filterSaveType] || DEFAULT_FILTER_SAVE_LIST_BY_TYPE_ITEM;
        if (!filterSaveListCurrent.loading) {
          setFilterData(filterSaveListCurrent?.data || []);
        }
      } else {
        if (!filterSaveListKpiTrends.loading) {
          setFilterData(filterSaveListKpiTrends?.data || []);
        }
      }
    } else {
      if (!filterSaveList.loading) {
        setFilterData(filterSaveList?.data || []);
      }
    }
  }, [
    JSON.stringify(filterSaveList),
    JSON.stringify(filterSaveListKpiTrends),
    JSON.stringify(filterSaveListByType),
    filterSaveType,
    useFilterSaveListByType,
  ]);

  /**
   * 向外提供
   * 1 从后端获取的筛选器保存的数据列表
   * 2 增/替换接口：参数为name, data,
   *
   * 保存时保存2套：data:{filter里面用的，一套是外面参数用的}
   */
  const handleRequest = async (requestFn: Function, params: any) => {
    setLoading(true);
    setError(false);
    let isSuccess = false;

    try {
      await requestFn(params);
      // showNotification('success', 'dbi_filterSave_successful_operation');
      showNotification('success', 'dbi_common_operation_succeed_tips');
      await getFilterSaveData();
      isSuccess = true;
    } catch (error) {
      // showNotification('error', 'dbi_filterSave_operation_failure');
      showNotification('error', 'dbi_common_operation_failed_tips');
      setError(true);
    } finally {
      setLoading(false);
    }
    return isSuccess;
  };

  const showNotification = (type: 'success' | 'error', messageId: string) => {
    const config = {
      description: formatMessage({ id: messageId }),
      className: 'filter-lock-alert',
      duration: 1000,
    };
    type === 'success' ? notification.success(config) : notification.error(config);
  };

  const updateFilterSave = async (params: { name: string; data: string }) => {
    let paramsValue = params;
    if (filterSaveType !== '') {
      paramsValue = {
        ...paramsValue,
        type: filterSaveType,
      } as any;
    }
    // console.log('paramsValueparamsValue',paramsValue)
    const isSuccess = await handleRequest(updateFilterSaveList, paramsValue);
    return isSuccess;
  };

  const removeFilterSave = async (params: { name: string }) => {
    let paramsValue = params;
    if (filterSaveType !== '') {
      paramsValue = {
        ...paramsValue,
        type: filterSaveType,
      } as any;
    }
    const isSuccess = await handleRequest(delFilterSaveList, paramsValue);
    return isSuccess;
  };

  const getFilterSaveData = async () => {
    const paramsValue = {};
    if (filterSaveType !== '') {
      if (useFilterSaveListByType) {
        await dispatch({
          type: `${FILTER_NAMESPACE}/getFilterSaveListByType`,
          payload: {
            ...paramsValue,
            type: filterSaveType,
          },
        });
      } else {
        await dispatch({
          type: `${FILTER_NAMESPACE}/getFilterSaveListTrends`,
          payload: paramsValue,
        });
      }
    } else {
      await dispatch({
        type: `${FILTER_NAMESPACE}/getFilterSaveList`,
        payload: paramsValue,
      });
    }
  };

  const getFilterItemByFilterName = (filterName: string) => {
    if (Array.isArray(filterData)) {
      const filterItem: any = filterData.filter((item: any) => {
        return item?.name === filterName;
      })[0];
      try {
        return JSON.parse(filterItem?.data);
      } catch (err) {
        return null;
      }
    }
    return null;
  };

  return {
    // 筛选器存起来的数据
    filterData,
    loading,
    error,
    getFilterSaveData,
    updateFilterSave,
    removeFilterSave,
    getFilterItemByFilterName,
  };
}

export default useFilterSaveHook;
